import React from 'react';
import image from "../../assets/Gemeinsamkeiten.jpg"
import {DelayedFrame} from "../DelayedFrame";

export function FolieGemeinsamkeiten(props) {
  return <DelayedFrame
    key={'similarity'}
    id={'similarity'}
    finish={props.finish}
    delay={60000}
  >
    <img src={image} alt={'Gemeinsamkeiten beachten.'} style={{width: "110%"}}/>

  </DelayedFrame>
}

